import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StandardLayout from '../../../components/layout/StandardLayout';
import { createExam } from '../../../services/examAPIService';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useAlert } from '../../../context/AlertContext';

const ExamCreateForm = () => {
    const [formData, setFormData] = useState({
        title: ''
    });
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { showAlert } = useAlert();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await createExam(formData);
            showAlert('Prüfung wurde erfolgreich erstellt', 'success', true);
            navigate('/admin');
        } catch (error) {
            console.error('Error creating exam:', error);
            setError('Fehler beim Erstellen der Prüfung');
        }
    };

    const handleCancel = () => {
        navigate('/admin');
    };

    return (
        <StandardLayout>
            <div className="container mx-auto px-4 py-8">
                <div className="max-w-2xl mx-auto">
                    <h1 className="text-2xl font-bold mb-6">Neue Prüfung erstellen</h1>
                    
                    {error && (
                        <div className="alert alert-error mb-4">
                            <XMarkIcon className="w-6 h-6" />
                            <span>{error}</span>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Titel</span>
                            </label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                className="input input-bordered w-full"
                                placeholder="Geben Sie den Titel der Prüfung ein"
                                required
                            />
                        </div>

                        <div className="flex justify-end gap-4">
                            <button
                                type="button"
                                onClick={handleCancel}
                                className="btn btn-ghost"
                            >
                                Abbrechen
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                            >
                                Prüfung erstellen
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </StandardLayout>
    );
};

export default ExamCreateForm; 